// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';
import 'swiper/css/a11y';

const { _x } = wp.i18n;

new Swiper('.simple-slider__carousel', {
  slidesPerView: 1,
  watchOverflow: true,
  navigation: {
    nextEl: '.simple-slider__carousel__navigation .swiper-button-next',
    prevEl: '.simple-slider__carousel__navigation .swiper-button-prev',
  },
  a11y: {
    prevSlideMessage: _x('Previous slide', 'swiper accessibility', 'vtx'),
    nextSlideMessage: _x('Next slide', 'swiper accessibility', 'vtx'),
    slideLabelMessage:
      _x('Slide ', 'swiper accessibility', 'vtx') +
      '{{index}}' +
      _x(' of ', 'swiper accessibility', 'vtx') +
      '{{slidesLength}}',
  },
  keyboard: {
    enabled: true,
  },
});
